import { render, staticRenderFns } from "./logisticsManage.vue?vue&type=template&id=64595dba&scoped=true"
import script from "./logisticsManage.vue?vue&type=script&lang=js"
export * from "./logisticsManage.vue?vue&type=script&lang=js"
import style0 from "./logisticsManage.vue?vue&type=style&index=0&id=64595dba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64595dba",
  null
  
)

export default component.exports